module.exports = __webpack_public_path__ + "static/img/s5.f17c1d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/s5.png
// module id = 6wUE
// module chunks = 0